module.exports = __webpack_public_path__ + "img/内容形式多样.3f36a097.png";